import axios from 'axios';

export const apiGetEmailDropdownsForCategory = (category) =>
  axios.get(`/api/admin/email-dropdown?category=${category}`);
